import { render, staticRenderFns } from "./SelectMun.vue?vue&type=template&id=43a943c4&lang=pug"
import script from "./SelectMun.vue?vue&type=script&lang=js"
export * from "./SelectMun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports